import {
  Box,
  Button,
  Grid,
  IconButton,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomButton from "../CustomComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import CustomSnackBar from "../CustomComponents/CustomSnackBar";
import { Delete } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const styles = makeStyles((theme) => {
  return {
    disabledButton: {
      color: "rgba(0, 0, 0, 0.26) !important",
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
    },
  };
});

const ListOfValue = () => {
  const [snackBarMessage, setSnackBarMessage] = useState("range missmatch");
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [datarows, setDatarows] = useState([]);
  // max value 1200 -> mobile.
  const [emptyValueFlag, setEmptyValueFlag] = useState(false);
  const [duplicateFlag, setDuplicateFlag] = useState(false);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
  const [discardOnDropDown, setDiscardOnDropDown] = useState(false);
  const [duplicateValueError, setDuplicateValueError] = useState(false);
  const [duplicateOrderError, setDuplicateOrderError] = useState(false);
  const userName = useSelector((state) => state.branch.userName);
  const [lovDescription, setLovDescription] = useState("");
  const [logDescriptionList, setLogDescriptionList] = useState([]);
  const [modifiedMap, setModifiedMap] = useState({});
  const [editAccess, setEditAccess] = useState(false);
  const [initialRecord, setInitialRecord] = useState();
  const [descriptionData, setDescriptionData] = useState([]);
  const [noModifiedSnackBarShow, setNoModifiedSnackBarShow] = useState(false);
  //State to maintain discard changes
  const [activeFilterValueMode, setActiveFilterValueMode] = useState("");
  const [currentactiveFilterValue, setCurrentactiveFilterValue] = useState("");
  const [modifiedState, setModifiedState] = useState();
  //Module Id List
  const [moduleIdList, setModuleIdList] = useState([]);
  const [moduleValue, setModuleValue] = useState("");
  const [moduleIdTouchHandler, setModuleIdTouchHandler] = useState(false);
  const moduleIdIsValid = moduleValue !== "" && moduleValue !== null;
  const moduleIDHasError = !moduleIdIsValid && moduleIdTouchHandler;
  const classes = styles();
  const [cashSavedDialogOpen, setCashSavedDialogOpen] = useState(false);

  //shortcut key
  const dispatch = useDispatch();
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const saveRef = useRef(null);
  const addRowRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [cashSavedDialogOpen]);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "listOfValue",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      savedDialogOpen && setSaveDialogOpen(false);
      cashSavedDialogOpen && setCashSavedDialogOpen(false);
    }
    let refList = {
      clearRef: clearRef,
      searchButtonRef: searchButtonRef,
      saveRef: saveRef,
      addRowRef: addRowRef,
    };
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "listOfValue",
        })
      );
    }
  };
  const discardDialogOnOkClickHandler = () => {
    if (activeFilterValueMode === "Description") {
      setLovDescription(currentactiveFilterValue.value);
      setLovDescriptionError(false);
    }
    if (activeFilterValueMode === "Clear") {
      setLovDescriptionError(false);
      discardChange();
    }
    if (activeFilterValueMode === "ModuleId") {
      setLovDescription(null);
      if (
        currentactiveFilterValue !== "" &&
        currentactiveFilterValue !== null
      ) {
        loadDescription(currentactiveFilterValue.value);
        setModuleValue(currentactiveFilterValue.value);
      } else {
        setModuleValue(null);
      }
    }
    setGridVisible(false);
    setDiscardDialogOpen(false);
  };

  useEffect(() => {
    let newRow = {
      id: 0,
      lovValues: "",
      lovOrder: "",
      lovStatus: "",
    };
    let newList = [];
    newList.push(newRow);
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toFixed()) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    setPage(1);
    loadDescription();
    getModuleID();
  }, []);
  const getModuleID = async () => {
    try {
      const response = await axios.post("/lovMaster/getModuleIds");
      const moduleList = response.data.map((data) => {
        return {
          value: data.moduleId,
          label: `${data.moduleName} - ${data.moduleId}`,
        };
      });
      setModuleIdList(moduleList);
    } catch {}
  };
  const loadDescription = async (moduleId) => {
    try {
      const response = await axios.post("/lovMaster/getLovByModleId", {
        moduleId: moduleId,
      });
      if (response.data) {
        setDescriptionData(response.data);
        const description = response.data.map((data) => {
          return {
            value: data.lovName,
            label: data.lovName,
          };
        });
        setEditAccess(response.data[0].lovEditAccess);

        setLogDescriptionList(description);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const onSaveButtonClickHandler = async () => {
    datarows.forEach((map, index) => {
      const loveCode = descriptionData.filter((data) => {
        return data.lovName === lovDescription;
      });
      map["createdBy"] = userName;
      map["lovCode"] = loveCode[0]?.lovCode;
      map["moduleId"] = moduleValue;
      map["lovName"] = lovDescription;
      map["updatedBy"] = modifiedBy;
    });
    try {
      const response = await axios.post("/lovMaster/insertLOVMaster", datarows);
      if (response.data === "saved") {
        setCashSavedDialogOpen(true);
      } else {
        setCashSavedDialogOpen(false);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerAlign: "center",
      align: "left",
      flex: 1,
      editable: false,
      hide: true,
      hideable: false,
      filterable: false,
      sortable: false,
    },
    {
      field: "lovValues",
      headerName: "Value",
      headerAlign: "center",
      align: "left",
      flex: 300,

      type: "string",
      editable: false,
      renderCell: (record) => {
        return (
          <TextField
            variant="standard"
            disabled={!editAccess}
            InputProps={{
              disableUnderline: true,
            }}
            sx={{ width: 300, flex: 1 }}
            value={record.row.lovValues}
            onChange={(e) => {
              const index = datarows.findIndex((data) => data.id === record.id);
              let activeRows = datarows[index];
              let updateRow = {
                ...activeRows,
                lovValues: e.target.value,
                // isModified: true,
              };
              let duplicateRow = [...datarows];
              duplicateRow[index] = updateRow;
              setDatarows(duplicateRow);
              setUpdateDisable(
                JSON.stringify(modifiedMap) ===
                  JSON.stringify(getModifiedData(duplicateRow))
              );
              setModifiedState(
                !(
                  JSON.stringify(duplicateRow) === JSON.stringify(initialRecord)
                )
              );
            }}
          />
        );
      },
    },
    {
      field: "lovOrder",
      headerName: "Order",
      headerAlign: "center",
      align: "left",
      flex: 200,

      type: "string",
      editable: false,
      renderCell: (record) => {
        return (
          <TextField
            variant="standard"
            disabled={!editAccess}
            InputProps={{
              disableUnderline: true,
              sx: {
                "& input": {
                  textAlign: "right",
                },
              },
            }}
            value={record.row.lovOrder}
            sx={{ width: 200, flex: 1 }}
            onChange={(e) => {
              const index = datarows.findIndex((data) => data.id === record.id);
              let activeRows = datarows[index];
              let updateRow = {
                ...activeRows,
                lovOrder: removeNonNumeric(e.target.value),
              };
              let duplicateRow = [...datarows];
              duplicateRow[index] = updateRow;
              setDatarows(duplicateRow);
              setUpdateDisable(
                JSON.stringify(modifiedMap) ===
                  JSON.stringify(getModifiedData(duplicateRow))
              );
              setModifiedState(
                !(
                  JSON.stringify(duplicateRow) === JSON.stringify(initialRecord)
                )
              );
            }}
          />
        );
      },
    },
    {
      field: "lovStatus",
      headerName: "Status",
      headerAlign: "center",
      align: "left",
      flex: 150,
      type: "string",
      editable: false,
      filterable: false,
      hideable: false,
      hideSortIcons: true,
      sortable: false,
      renderCell: (record) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              width: 150,
              flex: 1,
            }}
          >
            <Switch
              disabled={!editAccess}
              checked={record.row.lovStatus}
              onChange={(value) => {
                const index = datarows.findIndex(
                  (data) => data.id === record.id
                );
                let activeRows = datarows[index];
                let updateRow = {
                  ...activeRows,
                  lovStatus: value.target.checked,
                };
                let duplicateRow = [...datarows];
                duplicateRow[index] = updateRow;
                setDatarows(duplicateRow);
                setUpdateDisable(
                  JSON.stringify(modifiedMap) ===
                    JSON.stringify(getModifiedData(duplicateRow))
                );
                setModifiedState(
                  !(
                    JSON.stringify(duplicateRow) ===
                    JSON.stringify(initialRecord)
                  )
                );
              }}
            ></Switch>
          </Box>
        );
      },
    },

    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      width: 25,

      type: "number",
      disableColumnMenu: true,
      editable: false,
      filterable: false,
      hideable: false,
      hideSortIcons: true,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              width: 25,
              flex: 1,
            }}
          >
            <Tooltip title="Delete">
              <IconButton
                disabled={!editAccess}
                onClick={() => {
                  deleteSelectedRow(params);
                }}
              >
                <Delete sx={{ color: "black" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  //Button updation
  //Button state to show or Hide
  const [gridVisible, setGridVisible] = useState(false);
  const [savedDialogOpen, setSaveDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [paymentTypeError, setPaymentTypeError] = useState(false);
  const [lovDescriptionError, setLovDescriptionError] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(true);
  const [valueErrorSnackBarShow, setValueErrorSnackBarShow] = useState(false);
  const [orderErrorSnackBarShow, setOrderErrorSnackBarShow] = useState(false);
  const [gridEmtyErrorSnackBarShow, setGridEmtyErrorSnackBarShow] =
    useState(false);

  const [modifiedBy, setModifiedBy] = useState("");

  useEffect(() => {}, [datarows]);

  const handleSearch = () => {
    if (!lovDescription) {
      !lovDescription
        ? setLovDescriptionError(true)
        : setLovDescriptionError(false);
    } else {
      loadGridData();
      setGridVisible(true);
      setPaymentTypeError(false);
      setLovDescriptionError(false);
    }
  };

  const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

  const removeSpecialCharacters = (value) =>
    value.toString().replace(/[^a-zA-Z0-9\s]/g, "");

  const getModifiedData = (modifiedData) => {
    let modifiedMap = {};
    modifiedData.forEach(function (key) {
      modifiedMap[key["id"]] =
        key["lovValues"] + key["lovStatus"] + key["lovOrder"];
    });
    return modifiedMap;
  };

  const loadGridData = async (modifiedData) => {
    let map = {};
    const loveCode = descriptionData.filter((data) => {
      return data.lovName === lovDescription;
    });
    map["lovCode"] = loveCode[0]?.lovCode;
    map["moduleId"] = moduleValue;
    try {
      const response = await axios.post(
        "/lovMaster/getLovDetailsByLovName",
        map
      );
      if (response.data) {
        const responseWithId = response.data.map((data) => {
          return {
            ...data,
            id: Math.floor(Math.random() * 100),
          };
        });
        setInitialRecord(responseWithId);
        setDatarows(responseWithId);
        setPage(0);
        setModifiedState(false);
        setUpdateDisable(true);
        setModifiedMap(getModifiedData(responseWithId));
        setModifiedBy(response.data.modifiedBy);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const clearButtonClickHandler = () => {
    setActiveFilterValueMode("Clear");
    if (gridVisible && modifiedState) {
      setDiscardDialogOpen(true);
    } else {
      setLovDescriptionError(false);
      discardChange();
    }
  };

  //save action
  const valiateTosave = () => {
    if (datarows.length !== 0) {
      let lovValuesHasError = validateGridData()["lovValuesHasError"];
      let lovOrderHasError = validateGridData()["lovOrderHasError"];
      if (lovValuesHasError) {
        setValueErrorSnackBarShow(true);
      } else if (lovOrderHasError) {
        setOrderErrorSnackBarShow(true);
      } else {
        if (checkForDuplicateData()["duplicateValue"]) {
          setDuplicateValueError(true);
        } else if (checkForDuplicateData()["duplicateOrder"]) {
          setDuplicateOrderError(true);
        } else {
          if (JSON.stringify(datarows) === JSON.stringify(initialRecord)) {
            setNoModifiedSnackBarShow(true);
          } else {
            setSaveDialogOpen(true);
          }
        }
      }
    } else {
      setGridEmtyErrorSnackBarShow(true);
    }
  };

  const checkForDuplicateData = () => {
    let lovValues = [];
    let lovOrders = [];
    let duplicateValue = false;
    let duplicateOrder = false;
    datarows.forEach((data) => {
      duplicateValue = lovValues.includes(data["lovValues"]);
      duplicateOrder = lovOrders.includes(Number(data["lovOrder"]));
      lovValues.push(data["lovValues"]);
      lovOrders.push(Number(data["lovOrder"]));
    });
    return { duplicateValue: duplicateValue, duplicateOrder: duplicateOrder };
  };

  const validateGridData = () => {
    let lovValuesHasError = false;
    let lovOrderHasError = false;
    datarows.forEach((data) => {
      if (data["lovValues"] === "" || data["lovValues"].length > 50) {
        lovValuesHasError = true;
      }
      if (
        Number(data["lovOrder"]) === 0 ||
        data["lovOrder"] === "" ||
        Number(data["lovOrder"]) > 999
      ) {
        lovOrderHasError = true;
      }
    });
    return {
      lovValuesHasError: lovValuesHasError,
      lovOrderHasError: lovOrderHasError,
    };
  };

  //validate grid data
  const handleCellChangedEvent = (event) => {
    datarows[event.id][event.field] = event.value;
    setDatarows(datarows);
    setUpdateDisable(
      JSON.stringify(modifiedMap) === JSON.stringify(getModifiedData(datarows))
    );
    setModifiedState(
      !(JSON.stringify(datarows) === JSON.stringify(initialRecord))
    );
  };

  const discardChange = () => {
    setModuleIdTouchHandler(false);
    setModuleValue(null);
    setSaveDisabled(true);
    setGridVisible(false);
    setDiscardDialogOpen(false);
    setDatarows([]);
    setLovDescriptionError(false);
    if (!discardOnDropDown) {
      setLovDescription("");
    } else {
      setDiscardOnDropDown(false);
    }
  };

  const addNewRow = () => {
    let lovValuesHasError = validateGridData()["lovValuesHasError"];
    let lovOrderHasError = validateGridData()["lovOrderHasError"];

    if (lovValuesHasError) {
      setValueErrorSnackBarShow(true);
    } else if (lovOrderHasError) {
      setOrderErrorSnackBarShow(true);
    } else if (checkForDuplicateData()["duplicateValue"]) {
      setDuplicateValueError(true);
    } else if (checkForDuplicateData()["duplicateOrder"]) {
      setDuplicateOrderError(true);
    } else {
      let newRow = {
        id: datarows.length,
        lovValues: "",
        lovOrder: "",
        lovStatus: "",
      };
      setDatarows((prevRows) => [...prevRows, newRow]);
      setUpdateDisable(false);
    }
  };

  const deleteSelectedRow = (param) => {
    let newRows = datarows.filter((row) => row.id !== param.id);
    newRows.forEach((map, index) => {
      map["id"] = index;
    });
    setDatarows(newRows);
    setUpdateDisable(
      JSON.stringify(modifiedMap) === JSON.stringify(getModifiedData(newRows))
    );
    setModifiedState(
      !(JSON.stringify(newRows) === JSON.stringify(initialRecord))
    );
  };

  const goBtnhandler = () => {
    setModuleIdTouchHandler(true);
    if (gridVisible && !updateDisable) {
      setDiscardDialogOpen(true);
    } else {
      handleSearch();
    }
  };

  return (
    <>
      <div style={{ minHeight: "calc(100vh - 108px)" }}>
        <Grid
          container
          spacing={2}
          sx={{
            width: "calc(100% - 8px)",
            margin: "unset",
          }}
        >
          <AccordianContainer
            id="accord-jv"
            title="List Of Values"
            initialOpen={true}
          >
            <Box id="accord-box-jv-create" component="form" validate="true">
              <Grid item container spacing={1}>
                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <CustomAutoComplete
                    variant="standard"
                    type="text"
                    placeholder="Select Module ID"
                    label="Module ID"
                    required={true}
                    autoCompleteValues={moduleIdList}
                    value={moduleValue ?? null}
                    onChange={(e, value) => {
                      setActiveFilterValueMode("ModuleId");
                      setCurrentactiveFilterValue(value);
                      if (gridVisible && modifiedState) {
                        setDiscardDialogOpen(true);
                      } else {
                        setLovDescription(null);
                        setGridVisible(false);
                        if (value !== "" && value !== null) {
                          loadDescription(value.value);
                          setModuleValue(value.value);
                        } else {
                          setModuleValue(null);
                        }
                      }
                    }}
                    onBlur={() => {
                      setModuleIdTouchHandler(true);
                    }}
                  />
                  {moduleIDHasError && (
                    <p className="error">Please Select Module ID</p>
                  )}
                </Grid>
                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <CustomAutoComplete
                    variant="standard"
                    type="text"
                    placeholder="Select Description"
                    label="Description"
                    required={true}
                    disabled={moduleValue === null || moduleValue === ""}
                    autoCompleteValues={logDescriptionList}
                    value={lovDescription ?? null}
                    onChange={(e, value) => {
                      setActiveFilterValueMode("Description");
                      setCurrentactiveFilterValue(value);
                      if (gridVisible && modifiedState) {
                        setDiscardDialogOpen(true);
                      } else {
                        setLovDescription(value.value);
                        setLovDescriptionError(false);
                        setGridVisible(false);
                      }
                    }}
                    onBlur={() => {
                      setModuleIdTouchHandler(true);
                    }}
                  />
                  {lovDescriptionError && (
                    <p className="error">Please Select LOV Description</p>
                  )}
                </Grid>
                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <Box
                    sx={{
                      margin: "32px 4px 0px 4px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip title="Ctrl+F" placement="top">
                      <Button
                        sx={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                        }}
                        variant="contained"
                        onClick={goBtnhandler}
                        ref={searchButtonRef}
                      >
                        Go
                      </Button>
                    </Tooltip>
                    <Tooltip title="Ctrl+D" placement="top">
                      <Button
                        sx={{
                          marginLeft: "8px",
                          color: "white",
                          backgroundColor: "black",
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                        }}
                        onMouseOver={({ target }) => {
                          target.style.backgroundColor = "black";
                          target.style.color = "white";
                        }}
                        variant="contained"
                        onClick={() => clearButtonClickHandler()}
                        ref={clearRef}
                      >
                        Clear
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </AccordianContainer>
          {gridVisible && (
            <AccordianContainer
              id="accord-jv"
              title="Payment Details"
              initialOpen={true}
              sx={{ margin: "8px !important" }}
            >
              <>
                <div
                  style={{
                    direction: "rtl",
                    marginBottom: "4px",
                  }}
                >
                  <Tooltip title="Ctrl+S" placement="top">
                    <Button
                      disabled={!modifiedState || !editAccess}
                      sx={{
                        marginLeft: "8px",
                        color: "white",
                        backgroundColor: "#004a92",
                        fontWeight: "bold",
                        height: "2rem",
                      }}
                      classes={{ disabled: classes.disabledButton }}
                      onMouseOver={({ target }) => {
                        target.style.backgroundColor = "#004a92";
                        target.style.color = "white";
                      }}
                      variant="contained"
                      onClick={valiateTosave}
                      ref={saveRef}
                    >
                      {"Save"}
                    </Button>
                  </Tooltip>
                  <Tooltip title="Ctrl+A" placement="top">
                    <CustomButton
                      sx={{
                        marginLeft: "1rem",
                        color: "white",
                        backgroundColor: "#004a92",
                        fontWeight: "bold",
                        height: "2rem",
                      }}
                      disabled={!editAccess}
                      onMouseOver={({ target }) => {
                        target.style.backgroundColor = "#004a92";
                        target.style.color = "white";
                      }}
                      variant="contained"
                      onClick={() => addNewRow()}
                      ref={addRowRef}
                    >
                      +
                    </CustomButton>
                  </Tooltip>
                </div>
                <CustomDataGrid
                  noDataMessage="No Data"
                  noDataOnFilterMessage="No Data on Applied Filter"
                  rows={datarows}
                  columns={columns}
                  rowHeight={40}
                  pageSize={10}
                  pageSizeOptions={[10]}
                  gridLazyLoad={() => {}}
                  onSortModelChange={() => {}}
                  gridHeight={
                    datarows.length < 5 && datarows.length !== 0
                      ? datarows.length * 40 + 130
                      : 305
                  }
                  onCellKeyDown={(event, param) => {
                    (param.key === "e" || param.key === "E") &&
                      event.field === "lovOrder" &&
                      param.preventDefault();
                  }}
                  onCellEditCommit={(event) => handleCellChangedEvent(event)}
                />
              </>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              ></Box>
            </AccordianContainer>
          )}
        </Grid>
        <CustomConfirmationDialog
          dialogOpen={savedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Save List Of Values Details ?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            onSaveButtonClickHandler();
          }}
          onDialogClose={() => {
            setSaveDialogOpen(false);
          }}
        />{" "}
        <CustomConfirmationDialog
          dialogOpen={discardDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Are you sure want to discard changes ?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            discardDialogOnOkClickHandler();
          }}
          onDialogClose={() => {
            setDiscardDialogOpen(false);
          }}
        />
        <CustomConfirmationDialog
          dialogOpen={cashSavedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
          }
          dialogContent={
            <Typography sx={{ fontSize: "1rem" }}>
              List of Values Saved Successfully.
            </Typography>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => window.location.reload()}
        />
        <CustomConfirmationDialog
          dialogOpen={errorDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Error</Typography>
          }
          dialogContent={
            <>
              {emptyValueFlag && (
                <Typography sx={{ fontSize: "1rem" }}>
                  There are some record is empty in the table
                </Typography>
              )}
              {duplicateFlag && (
                <Typography sx={{ fontSize: "1rem" }}>
                  There are some duplicate record in the table
                </Typography>
              )}
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => setErrorDialogOpen(false)}
        />
      </div>

      <CustomSnackBar
        showSnackbar={valueErrorSnackBarShow}
        autoHideDuration={5000}
        onClose={() => {
          setValueErrorSnackBarShow(false);
        }}
        message={
          "Value should not be Empty & More than 50 characters in all rows"
        }
        severity="error"
        color={"red"}
      />

      <CustomSnackBar
        showSnackbar={orderErrorSnackBarShow}
        autoHideDuration={5000}
        onClose={() => {
          setOrderErrorSnackBarShow(false);
        }}
        message={"Order should be Range between 1 ~ 999 in all rows"}
        severity="error"
        color={"red"}
      />

      <CustomSnackBar
        showSnackbar={gridEmtyErrorSnackBarShow}
        autoHideDuration={5000}
        onClose={() => {
          setGridEmtyErrorSnackBarShow(false);
        }}
        message={"Data Should Not be Empty"}
        severity="error"
        color={"red"}
      />

      <CustomSnackBar
        showSnackbar={noModifiedSnackBarShow}
        autoHideDuration={5000}
        onClose={() => {
          setNoModifiedSnackBarShow(false);
        }}
        message={"No Modified Records"}
        severity="error"
        color={"red"}
      />

      <CustomSnackBar
        showSnackbar={duplicateValueError}
        autoHideDuration={5000}
        onClose={() => {
          setDuplicateValueError(false);
        }}
        message={"Value is duplicated."}
        severity="error"
        color={"red"}
      />

      <CustomSnackBar
        showSnackbar={duplicateOrderError}
        autoHideDuration={5000}
        onClose={() => {
          setDuplicateOrderError(false);
        }}
        message={"Order is duplicated."}
        severity="error"
        color={"red"}
      />

      <CustomSnackBar
        showSnackbar={showSnackBar}
        autoHideDuration={5000}
        onClose={() => {
          setShowSnackBar(false);
        }}
        message={snackBarMessage}
        severity="error"
      />
      <StlapFooter />
    </>
  );
};
export default ListOfValue;
